import {RootStore} from './index';
import {makeAutoObservable, action} from "mobx"
import AuthLoginModel from "../model/AuthLoginModel";
import UserModel from "../model/UserModel";

const APP_SITE_ID = 1;

export class AuthStore {
    private rootStore: RootStore | undefined;

    public email: string = '';
    public password: string = '';
    public error: string = '';
    public isShowPassword: boolean = false;

    public emailRecovery: string = '';
    public errorRecovery: string = '';
    public messageRecovery: string = '';
    public okRecovery: boolean = false;
    public isRememberPas: boolean = false;

    constructor(rootStore?: RootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }


    @action init = () => {
        let isRememberPas = localStorage.getItem('isRememberPas');
        let isRememberName = localStorage.getItem('isRememberName');
        if (isRememberPas?.length && isRememberName?.length) {
            this.password = isRememberPas;
            this.email = isRememberName;
            this.isRememberPas = true;
            //this.submitLogin();
        }
       // if(!user){
           this.getGuest(); 
       // }
    }


    @action
    setDemo() {
        this.email = 'sellwin.it@yandex.by';
        this.password = '111111111';
    }

    @action
    logout() {
        this.removeData();
        if (window.location.pathname !== "/login") {
            window.location.href = "/login";
        }
    }


    @action
    removeData() {
        localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("setInfoUser");
        localStorage.removeItem("getAllSection");
        localStorage.removeItem("activeClient");
    }

    @action
    onSubmitFormLogin = (e: { preventDefault: () => void; }) => {
        e.preventDefault()
        this.submitLogin();
        return false;
    }

    @action submitLogin = () => {

        AuthLoginModel.getToken(
            {
                siteId: APP_SITE_ID,
                email: this.email,
                password: this.password
            },
            this.setAuth,
            this.setError
        );
    }

    @action getGuest(){
        this.removeData()
        AuthLoginModel.getGuest(
            {
                siteId: APP_SITE_ID,
                email: '',
                password: ''
            },
            this.setAuthGuest,
            this.setError
        );
    }


    @action
    onLoginRoot = (id: number) => {
        if (window.confirm('авторизоваться под пользователем?')) {
            this.removeData();
            AuthLoginModel.getTokenRoot(
                id,
                this.setAuth,
                this.setError
            );
        }
    }


    @action
    setError = (error: any) => {
        if (
            error !== undefined &&
            error.response !== undefined &&
            error.response.data !== undefined &&
            error.response.data.message !== undefined
        ) {
            this.error = String(error.response.data.message);
        } else {
            this.error = String(error);
        }
    }

    @action
    setAuth = (result: any) => {
        this.error = '';
        localStorage.removeItem("activeClient");
        localStorage.setItem("token", result.data.token);
        localStorage.setItem("refreshToken", result.data.refreshToken);
        if (this.isRememberPas) {
            localStorage.setItem("isRememberPas", this.password);
            localStorage.setItem("isRememberName", this.email);
        } else {
            localStorage.removeItem("isRememberPas");
            localStorage.removeItem("isRememberName");
        }
        window.location.href = '/';
    }


    @action
    setAuthGuest = (result: any) => {
        this.error = '';
        localStorage.setItem("token", result.data.token);
        localStorage.setItem("refreshToken", result.data.refreshToken);
        if (this.isRememberPas) {
            localStorage.setItem("isRememberPas", this.password);
            localStorage.setItem("isRememberName", this.email);
        } else {
            localStorage.removeItem("isRememberPas");
            localStorage.removeItem("isRememberName");
        }
        this.rootStore?.mainStore.init();
       // window.location.href = '/';
    }


    @action
    onChangePassword = (e: { target: { value: string; }; }) => {
        this.password = e.target.value;
        this.error = '';
    }


    @action
    onChangeEmailRecovery = (e: { target: { value: string; }; }) => {
        this.emailRecovery = e.target.value;
        this.error = '';
    }


    @action
    onSubmitFormRecovery = () => {
        this.removeData();
        AuthLoginModel.getRecovery(
            {
                siteId: APP_SITE_ID,
                email: this.emailRecovery,
            },
            this.setRecovery,
            this.setErrorRecovery
        );
    }

    @action onRememberPas = () => {
        this.isRememberPas = !this.isRememberPas;
    }

    @action
    SetOkRecovery = (t: boolean) => {
        this.okRecovery = t;
    }

    @action
    setRecovery = (result: any) => {
        this.errorRecovery = '';
        // @ts-ignore
        this.okRecovery = true;
    }

    @action
    setErrorRecovery = (error: any) => {
        this.errorRecovery = String(error.response.data.message);
    }


    @action
    onChangeEmail = (e: { target: { value: string; }; }) => {
        this.email = e.target.value;
    }

    @action
    onShowPassword = () => {
        this.isShowPassword = !this.isShowPassword;
    }

}